import intlLocalesSupported from 'intl-locales-supported';
import intlPolyfill from 'intl';

export default function setIntlPolyfill() {
  const localesMyAppSupports = [
    'en', 'nl', 'fr',
  ];

  if (global.Intl) {
    // Determine if the built-in `Intl` has the locale data we need.
    if (!intlLocalesSupported(localesMyAppSupports)) {
      // `Intl` exists, but it doesn't have the data we need, so load the
      // polyfill and patch the constructors we need with the polyfill's.
      Intl.NumberFormat = intlPolyfill.NumberFormat;
      Intl.DateTimeFormat = intlPolyfill.DateTimeFormat;
    }
  } else {
    // No `Intl`, so use and load the polyfill.
    global.Intl = intlPolyfill;
  }
}



// WEBPACK FOOTER //
// ./js/utils/intl-polyfill.js